/*=========================================================================================
  File Name: moduleNaturalEntity.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleNaturalEntityState'
import mutations from './moduleNaturalEntityMutations'
import actions from './moduleNaturalEntityActions'
import getters from './moduleNaturalEntityGetters'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
